import { Dispatch } from "redux";
import * as types from './actionTypes';
import trainingAPI from '../services/trainingAPI'


// Action Creators
export const loadWeeklySummariesSuccess = (summaries: any[]) => ({
  type: types.LOAD_WEEKLY_SUMMARIES_SUCCESS,
  payload: summaries,
});

export const loadWeeklySummariesError = (error: string) => ({
  type: types.LOAD_WEEKLY_SUMMARIES_ERROR,
  payload: error,
});

// Thunk to Fetch Weekly Summaries
export const loadWeeklySummariesForDateRange = (userId: number, startDate: Date, endDate: Date) => {
    return async (dispatch: Dispatch) => {
      try {
        const summaries = await trainingAPI.getWeeklySummaries(userId, startDate, endDate);
        dispatch(loadWeeklySummariesSuccess(summaries));
      } catch (error: any) {
        dispatch(loadWeeklySummariesError(error.message || "Error loading weekly summaries"));
      }
    };
  };
